module.exports = __webpack_public_path__ + "static/media/baseball-kids.22c99973.mov";